import { useMediaQuery } from 'react-responsive';

// Default tailwind screens
// screens: {
//   'sm': '640px',
//   // => @media (min-width: 640px) { ... }

//   'md': '768px',
//   // => @media (min-width: 768px) { ... }

//   'lg': '1024px',
//   // => @media (min-width: 1024px) { ... }

//   'xl': '1280px',
//   // => @media (min-width: 1280px) { ... }
// }

type Hook = () => {
	isSmall: boolean;
	isMedium: boolean;
	isLarge: boolean;
	isXLarge: boolean;
};

const useScreenQuery: Hook = () => ({
	isSmall: useMediaQuery({ query: '(max-width: 768px)' }),
	isMedium: useMediaQuery({ query: '(min-width: 768px)' }),
	isLarge: useMediaQuery({ query: '(min-width: 1024px)' }),
	isXLarge: useMediaQuery({ query: '(min-width: 1280px)' }),
});

export default useScreenQuery;
